import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { catchError, map } from 'rxjs/operators';
import { AccountInfo } from '@azure/msal-browser';
import { MsalService } from '@azure/msal-angular';
import { Router } from '@angular/router';
import { AuthLogoutService } from '../nitro/services/auth-logout-service.service';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  account: AccountInfo | undefined;
  
  constructor(private readonly http: HttpClient, private readonly authService: MsalService, private readonly router: Router, private readonly logoutService: AuthLogoutService) {
    this.account = this.authService.instance.getAllAccounts()[0];
  }

  findAllMenu(): Observable<any> {

    let headers_objcts = new HttpHeaders({
      'Ocp-Apim-Subscription-Key': `${environment.apiSubscriptionMenuKey}`, /*'Authorization':'Basic  '*/
    });
    const httOptions = {
      headers: headers_objcts,
    }

    const id = (this.account) ? this.account?.localAccountId : '1';
   
    return this.http.get(`${environment.menuBackend}` + id ,httOptions)
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError((error: any) => {
          console.log(error);
          this.router.navigate(['./not-user-found']);
          return throwError(() => error);
          
        })
      );
  }

  findAllMenuByUser(): Observable<any> {
    
    let headers_objcts = new HttpHeaders({
      'Ocp-Apim-Subscription-Key': `${environment.apiSubscriptionMenuKey}`, /*'Authorization':'Basic  '*/
    });
    const httOptions = {
      headers: headers_objcts,
    }

    const id = (this.account) ? this.account?.localAccountId : '1';
   
    return this.http.get(`${environment.menuNewBackend}` + id ,httOptions)
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError((error: any) => {
          const status = error?.status;
          if (status === 401) {
            console.error('Token invalid. Logging out...', error);
            this.logoutService.showExpiredDialogAndLogout();
          } else {
            console.log(error);
            this.router.navigate(['./not-user-found']);
          }
          return throwError(() => error);
          
        })
      );

  }


  findAllMenusList(page?: number, limit?: number, name?: string): Observable<any> {
    let headers_objcts = new HttpHeaders({
      'Ocp-Apim-Subscription-Key': `${environment.apiSubscriptionRole}`,
    });

    let params = new HttpParams();
    params = params.set('name', (name) ?? '');
    params = params.set('limit', (limit) ?? '');
    params = params.set('page', (page) ?? '');
    params = params.set('sortBy', 'position');

    const httOptions = {
      headers: headers_objcts,
      params: params,
    }

    return this.http.get(`${environment.menusBOBackend}s`,httOptions)
    .pipe(
      map((data: any) => {
        return data;
      }),
      catchError((error: any) => {
        const status = error?.status;
        if (status === 401) {
          console.error('Token invalid. Logging out...', error);
          this.logoutService.showExpiredDialogAndLogout();
        } else {
          console.log(error);
        }


        return throwError(() => error);
      })
    );
  }

  editMenus(user: any, id: any) {
    
    let headers_objcts = new HttpHeaders({
      'Ocp-Apim-Subscription-Key': `${environment.apiSubscriptionRole}`,
    });
    let params = new HttpParams();

    const httOptions = {
      headers: headers_objcts,
      params: params,
    }
    return this.http.put(`${environment.menusBOBackend}/${id}`, user, httOptions)
    .pipe(
      map((data: any) => {
        return data;
      }),
      catchError((error: any) => {
        
        const status = error?.status;
        if (status === 401) {
          console.error('Token invalid. Logging out...', error);
          this.logoutService.showExpiredDialogAndLogout();
        } else {
          console.log(error);
        }
        return throwError(() => error);
      })
    );
  }


  saveMenus(user: any) {
    
    let headers_objcts = new HttpHeaders({
      'Ocp-Apim-Subscription-Key': `${environment.apiSubscriptionRole}`,
    });
    let params = new HttpParams();

    const httOptions = {
      headers: headers_objcts,
      params: params,
    }
    return this.http.post(`${environment.menusBOBackend}`, user, httOptions)
    .pipe(
      map((data: any) => {
        return data;
      }),
      catchError((error: any) => {
        
        const status = error?.status;
        if (status === 401) {
          console.error('Token invalid. Logging out...', error);
          this.logoutService.showExpiredDialogAndLogout();
        } else {
          console.log(error);
        }
        return throwError(() => error);
      })
    );
  }
}
